import { Modal } from "bootstrap";
import Utils from "./utils";

export default class Chatbot {
    rootElement: HTMLElement;

    speechBubbleCookieName: string;
    chatbotCookieName: string;
    redirectUrl: string
    constructor(private uniqueID: string, speechBubbleCookieName: string, chatbotCookieName: string, redirectUrl: string) {
        this.rootElement = document.getElementById(this.uniqueID) as HTMLElement;
        if (!this.rootElement) return;

        this.speechBubbleCookieName = speechBubbleCookieName;
        this.chatbotCookieName = chatbotCookieName;
        this.redirectUrl = redirectUrl;
        this.init()
        this.applySticky();
        window.addEventListener('resize', this.applySticky.bind(this))
    }

    init() {
        const speechBubbleCookie = Utils.GetCookie(this.speechBubbleCookieName);
        const speechBubbleWrapper = this.rootElement.querySelector('.speech-bubble__wrapper');
        if (speechBubbleWrapper) {
            const speechBubbleDismissButton = speechBubbleWrapper.querySelector('button');
            speechBubbleDismissButton.addEventListener('click', () => {
                Utils.SetCookie(this.speechBubbleCookieName, "1", 14);
                speechBubbleWrapper.classList.remove('active')
            })
            if (speechBubbleCookie == "1") {
                speechBubbleWrapper.classList.remove('active')
            }
        }

        const chatbotButton = this.rootElement.querySelector('.chatbot-button');

        const targetModalId = chatbotButton.getAttribute('data-bs-target');
        const modalElement = document.querySelector(targetModalId)
        if (modalElement) {
            const targetModal = new Modal(modalElement)
            chatbotButton.removeAttribute('data-bs-target');
            chatbotButton.addEventListener('click', (e) => {
                const chatbotCookie = Utils.GetCookie(this.chatbotCookieName)

                if (chatbotCookie == "1") {
                    e.preventDefault();
                    e.stopPropagation()
                    window.location.href = this.redirectUrl
                } else {
                    targetModal.show()
                }
            })
        }
    }
    applySticky() {
        const footerLower = document.querySelector('.footer__lower');
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                this.rootElement.classList.add("stopped");
                this.rootElement.style.transform = `translateY(-${footerLower.clientHeight}px)`
            } else {
                this.rootElement.classList.remove("stopped");
                this.rootElement.style.transform = "translateY(0)"
            }
        }, {
            root: null,
            threshold: 0,
        });
        observer.observe(footerLower);
    }
}